export default __webpack_public_path__ + "static/media/017-daughter.eecb2795.png";